var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrenade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0535 3.87785C23.9076 -0.927414 17.1833 -1.42078 16.3054 3.26375L14.1408 1.09916C13.9869 0.945207 13.7781 0.858682 13.5604 0.858682H7.40533C6.95196 0.858682 6.58441 1.22623 6.58441 1.6796V6.13444H4.76745C4.31409 6.13444 3.94653 6.50199 3.94653 6.95536V27.1791C3.94653 27.6324 4.31409 28 4.76745 28H17.0776C17.531 28 17.8985 27.6324 17.8985 27.1791V7.77628H18.489C21.2776 10.7343 21.5324 14.115 21.5324 15.4462V17.5068C21.5758 18.596 23.1313 18.5952 23.1743 17.5068V15.4462C23.1743 11.4995 21.3969 8.79799 20.6093 7.74891C22.5456 7.52316 24.0535 5.87372 24.0535 3.87785ZM16.2566 26.3582H5.58831V24.4828H16.2566V26.3582ZM16.2566 22.841H5.58831V20.9657H16.2566V22.841ZM16.2566 19.3238H5.58831V7.77628H16.2566V19.3238ZM8.22625 6.13444V2.50052H13.2203L16.8542 6.13444H8.22625ZM17.8985 3.87785C17.8985 2.63356 18.9108 1.62126 20.155 1.62126C23.1488 1.74522 23.1479 6.01098 20.155 6.1345C18.9108 6.13444 17.8985 5.12214 17.8985 3.87785Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrenade);
export default __webpack_public_path__ + "static/media/grenade.18d35af5.svg";
export { ForwardRef as ReactComponent };